import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FilterRatingStateScheme, RatingType } from '../types/filterRating'

const initialState: FilterRatingStateScheme = {
	type: 'general',
}

export const filterRatingSlice = createSlice({
	name: 'FilterRating',
	initialState,
	reducers: {
		changeTypeReducer: (state, action: PayloadAction<RatingType>) => {
			state.type = action.payload
		},
	},
})

export const { actions: filterRatingActions } = filterRatingSlice
export const { reducer: filterRatingReducer } = filterRatingSlice
